export default {
  system: {
    user: 'Пользователь',
    level: 'Уровень',
    earnPerTap: 'Прибыль за тап',
    coinsToLevelUp: 'Монет для апа',
    profitPerHour: 'Прибыль в час',
    coming1: 'Скоро здесь будет',
    coming2: 'что-то интересное...',
    close: 'Закрыть',
    friends: 'Друзья',
    continue: 'Продолжить',
  },
  settings: {
    chooseNetwork: 'Выбери сеть',
    chooseLanguage: 'Выбери язык',
  },
  popup_CheckTask: {
    join: 'Подписаться',
    check: 'Проверить',
    taskIsNotCompleted: 'Задача не выполнена',
  },
  popup_levelUp: {
    levelUp: 'Уровень повышен!',
    multiTap: 'Мультитап',
    energyLimit: 'Лимит энергии',
  },
  popup_BalanceUp: {
    balanceUp: 'Баланс поднят!',
    balanceDiffSinceLast: 'Ваша награда',
  },
  popup_BalanceTip: {
    tip: 'Увеличьте свою прибыль',
    message: 'Нажмите меню Майн, чтобы купить улучшения для своей сети',
    description: 'Зарабатывайте даже в режиме офлайн до 3 часов',
  },
  popup_Bored: {
    header: 'Лягушка заскучала!',
    message: 'Поиграйте с лягушкой.',
    description: 'Если с лягушкой не играть 3 часа, прибыль прекращается',
  },
  popup_Hungry: {
    header: 'Лягушка проголодалась!',
    message: 'Покормите лягушку.',
    description: 'Чем больше у Вас друзей, тем больше монет сможет принести каждое кормление',
  },
  menu: {
    network: 'Сеть',
    mine: 'Майн',
    earn: 'Деньги',
    food: 'Еда',
  },
  tap: {
    bored: 'Скучно',
    fun: 'Весело',
  },
  mineMenu: {
    activities: 'Активности',
    investments: 'Инвестиции',
    web3: 'WEB3',
    achievements: 'Достижения',
  },
  mine: {
    joinOurTG1: 'Залетай в наш телеграм-канал,',
    joinOurTG2: 'чтобы разблокировать!',
    unlock: 'Разблокировать',
  },
  leaderboard: {
    from: 'от',
    beTheFirst: 'Стань первым!',
  },
  friends: {
    inviteFriends: 'Пригласите друзей!',
    receiveBonuses: 'Вы и ваш друг получите бонусы',
    inviteFriend: 'Пригласить друга',
    withTelegramPremium: 'с Telegram Premium',
    forYouAndYourFriend: 'для вас и вашего друга',
    moreBonuses: 'Больше бонусов',
    listOfYourFriends: 'Список ваших друзей',
    linkCopied: 'Ссылка-приглашение скопирована в буфер обмена!',
    playWithMe:
      'Присоединяйся ко мне и играй, чтобы получать токены через аирдроп!\n' +
      '💰 Лови подарок! +3000 монет для тех, кто зашел впервые\n' +
      '🚀 У тебя есть Telegram Premium? Получи +5000 монет!\n',
  },
  earn: {
    moreCoins: 'Заработай больше монет!',
    dailyTasks: 'Ежедневные задания',
    dailyReward: 'Ежедневная награда',
    tasksList: 'Список заданий',
    joinOurTG: 'Присоединяйся к нашему Telegram каналу',
    followOurX: 'Следи за нашим аккаунтом в X',
    yourAd: 'Здесь может быть Ваша реклама',
    connect: 'Свяжитесь с админом нашего Telegram канала',
  },
  food: {
    hungry: 'Голодный',
    full: 'Сытый',
    frogIsFull: 'Лягушка сыта',
    feed: 'Покормить',
    bonus: 'Бонус',
    satiety: 'Сытость',
    hours: 'часа',
  },
  toast: {
    buyCard: {
      title: 'Достижение разблокировано!',
      subtitle: 'Время вести свою империю лягушки к величию 👑',
    },
    feedFrog: {
      title: 'Лягушка счастлива!',
      subtitle: 'Отличная работа! Кормите своего питомца, чтобы он продолжал улыбаться 🍽️',
    },
  },
};
